const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const SCRIPT_ID = "google-recaptcha-v3";

const loadRecaptcha = () => {
  if (!SITE_KEY || typeof window === "undefined") return Promise.resolve(null);
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
  const existing = document.getElementById(SCRIPT_ID);
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener("load", () => resolve(window.grecaptcha), { once: true });
      existing.addEventListener("error", reject, { once: true });
    });
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}&trustedtypes=true`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.grecaptcha);
    script.onerror = () => reject(new Error("reCAPTCHA failed to load"));
    document.head.appendChild(script);
  });
};

export const getSignupRecaptchaToken = async () => {
  const recaptcha = await loadRecaptcha();
  if (!recaptcha || !SITE_KEY) return undefined;
  return new Promise((resolve, reject) => {
    recaptcha.ready(() => {
      recaptcha.execute(SITE_KEY, { action: "signup" }).then(resolve, reject);
    });
  });
};
